class BasketIndicatorController {

    constructor(basket) {
        this.basket = basket;
    }
}

BasketIndicatorController.$inject = [ 'basket' ];

export default BasketIndicatorController;


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/basket.indicator.controller.js